import React, { useState } from "react";
import { Card, Radio } from "antd";

const ReviewScore = ({ category, descriptions = [], value, onChange }) => {

  const items = [
    { rate: 4, scale: "Exceeds", points: 100, description: descriptions[0] || "" },
    { rate: 3, scale: "Meets", points: 75, description: descriptions[1] || "" },
    { rate: 2, scale: "Needs improvement", points: 50, description: descriptions[2] || "" },
    { rate: 1, scale: "Does not meet expectations", points: 25, description: descriptions[3] || "" },
  ];

  const scaleMap = {
    "Does not meet expectations": "Needs Focus",
    "Needs improvement": "Developing",
    "Meets": "Meets",
    "Exceeds": "Exceeds",
  };

  const handleChange = (e) => onChange(category, e.target.value);
  const selectedItem = items.find((item) => item.rate === value);

  const getStatusClass = (scale) =>
    (scaleMap[scale] || "")
      .toLowerCase()
      .replace(/\s+/g, "-");

  return (
    <Card className="my-3 rounded-xl dark:bg-intsamis-900 dark:border-slate-700">
      <div className="flex justify-between mb-3">
        <h5 className="font-semibold text-[15px] dark:text-white">{category}</h5>
        {selectedItem && (
          <span className={`text-xs font-medium status-indicator ${getStatusClass(selectedItem.scale)}`}>
            {selectedItem.scale}
          </span>
        )}
      </div>

      <Radio.Group value={value} onChange={handleChange} className="w-full dark:bg-instamis-800  dark:hover:border-emerald-100">
        <div className="flex flex-col gap-3">
          {items.map((item) => (
            <label
              key={item.rate}
              className="flex items-start justify-between p-4 border-2 rounded-lg cursor-pointer hover:border-slate-300 dark:border-slate-700"
            >
              <div className="flex items-start gap-3">
                <Radio value={item.rate} className="green-radio" />
                <div>
                  <div className="flex items-baseline gap-2 mb-1 dark:text-white">
                    <span className="font-semibold text-[14px]">{item.rate}</span>
                    <span className="text-[14px] font-medium">{item.scale}</span>
                  {item.description && (
                    <p className="text-[13px] text-gray-500 ml-6 dark:text-gray-100">{item.description}</p>
                  )}
                </div>
              </div>

              </div>
              <span className={`text-xs font-medium status-indicator ${getStatusClass(item.scale)}`}>
                {item.points} pts
              </span>
            </label>
          ))}
        </div>
      </Radio.Group>
    </Card>
  );
};

export default ReviewScore;
